import React from "react";

import { useProgressBarContext } from "../../../context/ProgressBarContext";
import { CartText } from "../components/CartText";
import { Container } from "../components/Container";

import { ProgressBar } from "./ProgressBar";

export const ProgressBar2 = () => {
  const { device } = useProgressBarContext();
  const { swapTextPositions } = device.widget.styles.layout;

  return (
    <Container>
      {!swapTextPositions ? (
        <>
          <ProgressBar />
          <CartText />
        </>
      ) : (
        <>
          <CartText />
          <ProgressBar />
        </>
      )}
    </Container>
  );
};
